// prettier-ignore
const dates = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]

// prettier-ignore
const workingHours = [8,9,10,11,12,13,14,15,16,17]

// prettier-ignore
const minutes = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59]

export const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const breathingRoom = 15; // 15 minutes

// prettier-ignore
export const months = [
  { id: 1, abbr: "Jan", name: "January"},
  { id: 2, abbr: "Feb", name: "February"},
  { id: 3, abbr: "Mar", name: "March"},
  { id: 4, abbr: "Apr", name: "April" },
  { id: 5, abbr: "May", name: "May" },
  { id: 6, abbr: "Jun", name: "June" },
  { id: 7, abbr: "Jul", name: "July" },
  { id: 8, abbr: "Aug", name: "August" },
  { id: 9, abbr: "Sep", name: "September" },
  { id: 10, abbr: "Oct", name: "October" },
  { id: 11, abbr: "Nov", name: "November" },
  { id: 12, abbr: "Dec", name: "December" },
];

export function isLeapYear(year) {
  return (year % 4 == 0 && year % 100 != 0) || year % 400 == 0;
}

export function structDate(day, month, year) {
  // console.log(typeof day);
  return new Date(`${day} ${month} ${year}`).toString();
}

export function destructDate(param) {
  // console.log(param);
  const date = new Date(param);

  const currentDay = date.getDate();
  const currentHour = date.getHours();
  const currentMinutes = date.getMinutes();

  // console.log(currentHour);

  let day = currentDay;
  if (currentHour > workingHours[workingHours.length - 1]) day = currentDay + 1;

  let month = months[date.getMonth()].abbr;
  let year = date.getFullYear();

  let hour = currentHour;
  if (hour > workingHours[workingHours.length - 1] || hour < workingHours[0])
    hour = workingHours[0];
  hour = hour < 10 ? `0${hour}` : String(hour);

  let minute = currentMinutes;
  if (
    day === currentDay &&
    currentHour > workingHours[0] &&
    currentHour > workingHours[workingHours.length - 1]
  ) {
    if (minute + breathingRoom > 59) minute = minute + (breathingRoom % 60);
    else minute = minute + breathingRoom;
  } else minute = 0;
  minute = minute < 10 ? `0${minute}` : String(minute);

  return [day, month, year, hour, minute];
}

export function getDayOfWeek(day, month, year) {
  return weekdays[new Date(`${day} ${month} ${year}`).getDay()];
}

export function timeDates(param, fromToday) {
  const month30Days = ["APR", "JUN", "SEP", "NOV"];
  const month30DaysInt = [4, 6, 9, 11];

  const { month, year } = param;
  let mnth = month;

  let returnDates = dates;

  if (typeof mnth === "string") mnth = mnth.toUpperCase(mnth.slice(0, 3));

  if (mnth === 2 || mnth === "FEB") {
    const febDates = dates.filter((date) => date < 29);

    returnDates = year && isLeapYear(year) ? [...febDates, 29] : febDates;
  } else if (month30Days.includes(mnth) || month30DaysInt.includes(mnth)) {
    let dates30 = dates;
    dates30.pop();
    returnDates = dates30;
  }

  const now = new Date();
  if (
    fromToday &&
    months[now.getMonth()].abbr.toUpperCase() === mnth &&
    now.getFullYear() === year
  ) {
    const today = new Date().getDate();
    const currentHour = new Date().getHours();

    // console.log(currentHour);

    if (currentHour > workingHours[workingHours.length - 1]) {
      returnDates = returnDates.filter((date) => date > today);
    } else {
      returnDates = returnDates.filter((date) => date >= today);
    }
  }

  return returnDates;
}

export function timeMonths(fromToday, year) {
  let returnMonths = months;
  const thisMonth = new Date().getMonth();
  const thisYear = new Date().getFullYear();
  if (fromToday && thisYear === year) {
    returnMonths = returnMonths.filter((month, index) => index >= thisMonth);
  }

  return returnMonths;
}

export function timeYears() {
  const thisYear = new Date().getFullYear();

  return [thisYear, thisYear + 1];
}

export function timeHours(day, month, year) {
  const today = new Date();
  let availableHours = workingHours;
  if (
    day === today.getDate() &&
    months[today.getMonth()].abbr === month &&
    year === today.getFullYear()
  ) {
    const baseHour =
      today.getMinutes() + breathingRoom > 59
        ? today.getHours() + 1
        : today.getHours();
    availableHours = availableHours.filter((hour) => hour >= baseHour);
  }

  return availableHours.map((value) =>
    value < 10 ? `0${value}` : String(value)
  );
}

export function timeMinutes(day, month, year, hours) {
  const today = new Date();
  let availableMinutes = minutes;
  if (
    day === today.getDate() &&
    months[today.getMonth()].abbr === month &&
    year === today.getFullYear() &&
    hours == today.getHours()
  ) {
    const baseMin =
      today.getMinutes() + breathingRoom > 59
        ? (today.getMinutes() + breathingRoom) % 60
        : today.getMinutes() + breathingRoom;
    availableMinutes = availableMinutes.filter((minute) => minute >= baseMin);
  }

  return availableMinutes.map((value) =>
    value < 10 ? `0${value}` : String(value)
  );
}
